import { render, staticRenderFns } from "./AltaPsp.vue?vue&type=template&id=0aaef02a&scoped=true"
import script from "./AltaPsp.vue?vue&type=script&lang=js"
export * from "./AltaPsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaef02a",
  null
  
)

export default component.exports